import { useTranslation } from 'react-i18next';
import { SettingsButton } from '@/components/button/SettingsButton';
import { OnboardingTooltip } from '@/components/onboarding/OnboardingTooltip';
import { OnboardingItemKey } from '@/types/userConfigs';

type OnboardingSettingsButtonProps =
  | { itemKey?: never; header?: never; content?: never }
  | { itemKey: OnboardingItemKey; header: string; content: string };

export const OnboardingSettingsButton = ({
  itemKey = OnboardingItemKey.APPEARANCE_SETTINGS,
  header,
  content,
}: OnboardingSettingsButtonProps) => {
  const { t } = useTranslation('onboarding');

  return (
    <OnboardingTooltip
      itemKey={itemKey}
      header={header ?? t('appearanceSettings.header')}
      content={content ?? t('appearanceSettings.content')}
    >
      <SettingsButton />
    </OnboardingTooltip>
  );
};
